import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CatalogFilterState } from "../types/reducers";

const initialState: CatalogFilterState = {
  species: {},
  imageTypes: {
    mosquito: true,
    mesh: true,
    emptyMesh: false,
    debris: false,
    bycatch: true,
    bookmarked: false,
  },
  trapsites: [],
  devices: [],
  capturedAfter: null,
  capturedBefore: null,
  page: 0,
  hasSeededDevices: false,
  hasSeededTrapsites: false,
};

const catalogFilterSlice = createSlice({
  name: "catalogFilter",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<CatalogFilterState>>) => {
      const { page, imageTypes, hasSeededDevices, hasSeededTrapsites, ...otherFilters } = action.payload;

      let isFilterChanged = false;

      if (imageTypes) {
        state.imageTypes = { ...state.imageTypes, ...imageTypes };
        isFilterChanged = true;
      }

      if (hasSeededDevices !== undefined) state.hasSeededDevices = hasSeededDevices;
      if (hasSeededTrapsites !== undefined) state.hasSeededTrapsites = hasSeededTrapsites;

      if (Object.keys(otherFilters).length > 0) {
        Object.assign(state, otherFilters);
        isFilterChanged = true;
      }

      // If page is explicitly provided, use it.
      // Otherwise, if any filter is changed, reset page to 0.
      if (page !== undefined) {
        state.page = page;
      } else if (isFilterChanged) {
        state.page = 0;
      }
    },
    resetCatalogFilters: () => initialState,
  },
});

export const { setFilters, resetCatalogFilters } = catalogFilterSlice.actions;

export default catalogFilterSlice.reducer;
